<template>
  <div class="flex flex-col mt-3">
    <Modal
      ref="vendorSelectorModal"
      size="full"
      width="max"
      anchor="center">
      <template #title>Select Vendor</template>
      <template #content>
        <form>
          <SearchForm
            v-model="search"
            @search="onSearch"
          />
        </form>
        <div class="flex flex-col p-2 bg-gray-200 rounded-md">
          <Spinner
            v-if="displayLoadingSpinner"
            message="Loading Vendors"
            :size="16"
          />
          <div class="px-2 bg-blue-200 font-bold rounded-md"
            v-if="search">
            {{ search }}
          </div>
          <div
            v-for="vendor in filteredVendors"
            :key="vendor.id">
            <div class="flex flex-row hover:bg-gray-100"
              :class="{
                'border-black': selectedVendorId === vendor.id,
                'border-2': selectedVendorId === vendor.id,
                'border-lg': selectedVendorId === vendor.id,
                'border-0': selectedVendorId !== vendor.id,
              }"
              @click="selectEntry(vendor.id)">
              <span class="px-2 w-16">
                {{ vendor.id }}
              </span>
              <span class="px-2 w-48 truncate">
                {{ vendor.partition.description }}
              </span>
              <span class="px-2 w-24">
                {{ vendor.abbreviation }}
              </span>
              <span class="px-2 min-w-48 max-w-full">
                {{ vendor.name }}
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <Button class="rounded-md px-3 py-2 transition-colors shadow-sm"
          color="blue"
          @click="addValue">
          Add
        </Button>
      </template>
    </Modal>
  </div>
</template>


<script>
import Modal from '../../Modal.vue'
import Button from '../../Button.vue'
import Spinner from '../../Spinner.vue'
// import TextField from '../../formComponents/TextField.vue'
import SearchForm from '../../Search/SearchForm.vue'

import { filter } from 'lodash'

import userManagementService from '../../../services/pages/userManagement.js'

export default {
  components: {
    Modal,
    Button,
    Spinner,
    // TextField,
    SearchForm,
  },
  props: {},
  data() {
    return {
      vendors: {},
      selectedVendorId: undefined,

      displayLoadingSpinner: false,

      search: undefined,
      formValues: undefined,
    }
  },
  mounted() {
    userManagementService.registerSelectorModal(
      'vendor',
      () => {
        this.$refs['vendorSelectorModal'].openModal()
        this.displayLoadingSpinner = true
        userManagementService.getConfigContent(['vendor', 'partition'])
          .then((data) => {
            this.displayLoadingSpinner = false
            this.vendors = data['vendors']
          })
      },
      () => {
        this.$refs['vendorSelectorModal'].closeModal()
      },
    )
  },
  methods: {
    selectEntry(vendorId) {
      this.selectedVendorId = vendorId
    },
    onSearch() {
      console.log('onSearch')
    },
    addValue() {
      userManagementService.closeSelectorModal('vendor', this.vendors[this.selectedVendorId])
      this.selectedVendorId = undefined
    },
  },
  computed: {
    filteredVendors() {
      if (this.search) {
        return filter(this.vendors, (vendor) => {          
          return vendor.name?.toLowerCase().includes(this.search.toLowerCase()) ||
            vendor.abbreviation?.toLowerCase().includes(this.search.toLowerCase()) ||
            vendor.partition?.description?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      else {
        return this.vendors
      }
    }
  },
}
</script>
